import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const BoardImage = (props) => {
  const data = useStaticQuery(graphql`
    query {
      boardImage: file(
        relativePath: { eq: "components/BoardImage/board-image.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 5494, maxHeight: 3784, cropFocus: NORTHEAST) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `)

  return <Img fluid={data.boardImage.childImageSharp.fluid} {...props} />
}

export default BoardImage
